import { useState, type FormEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ApiError, api } from '@/api/client'
import { safeNext } from '@/lib/loginRedirect'
import { BrandMark, BuildStamp, Button, Field, Input } from '@/ui'

export default function Login() {
  const nav = useNavigate()
  const [params] = useSearchParams()
  const expired = params.get('expired') === '1'
  const [email, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setErr('')
    setLoading(true)
    try {
      await api.login(email, pass)
      nav(safeNext(params.get('next')), { replace: true })
    } catch (e) {
      setErr(
        e instanceof ApiError && e.status >= 500
          ? `서버가 응답하지 않는다 (${e.status}). 잠시 뒤 다시 시도한다.`
          : '이메일이나 비밀번호가 맞지 않는다.',
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 py-10 text-foreground">
      <div className="w-full max-w-[22rem]">
        <div className="mb-7 flex flex-col items-center gap-3 text-center">
          <BrandMark size={44} />
          <h1 className="flex items-baseline gap-2">
            <span className="text-title font-bold">Viral</span>
            <span className="text-body text-muted-foreground">운영 콘솔</span>
          </h1>
        </div>
        <form
          onSubmit={onSubmit}
          aria-label="로그인"
          className="space-y-4 rounded-xl border border-border bg-card p-5 shadow-sm"
          noValidate
        >
          {expired && (
            <p role="status" className="rounded-md bg-muted px-3 py-2 text-table text-muted-foreground">
              로그인이 끝났다. 다시 로그인한다
            </p>
          )}
          <Field label="이메일">
            <Input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </Field>
          <Field label="비밀번호" error={err || undefined}>
            <Input
              type="password"
              autoComplete="current-password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              required
            />
          </Field>
          <Button type="submit" variant="primary" loading={loading} disabled={!email || !pass} className="w-full">
            로그인
          </Button>
        </form>
        <div className="mt-4 text-center">
          <BuildStamp className="text-muted-foreground" />
        </div>
      </div>
    </div>
  )
}
